import { toast } from '@hivebrite/design-system/Toast';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { type UserPostProps } from '../types';

interface GetTopicNewPostParams {
  topicId: number;
}

export const getTopicNewPost = ({ topicId }: GetTopicNewPostParams) =>
  axios
    .get<{
      topic_post: UserPostProps;
    }>(Routes.new_topics_topic_post_path(topicId))
    .then(({ data }) => data.topic_post)
    .catch(() => {
      toast.error(__('Sorry, an error occurred'));
    });
